<template>
  <div class="b2c-teacher-wrapper">
    <div class="teacher-company">
      <template v-if="omsType === warehousing">
        <span class="intro">转转官方验机中心出具</span>
        <span class="time">质检时间：{{ qualityTeacherMsg.joinDate }}</span>
        <img
          :src="
            $setPicSize(
              'https://pic2.zhuanstatic.com/zhuanzh/af5a2e81-5a2a-41f5-b395-4bc60a7f3569.png',
              150,
              150
            )
          "
          alt=""
      /></template>
      <template v-else>
        <span class="intro">平台认证商户根据转转验机标准出具</span>
        <span class="time"
          >质检时间：{{ qualityTeacherMsg.joinDate }}
          <span
            class="notes"
            @click="
              () => {
                showNotes = true
              }
            "
            >商户验收说明
            <img
              class="notes-img"
              :src="
                $setPicSize(
                  'https://pic4.zhuanstatic.com/zhuanzh/be98fe85-9cd2-41b1-b8df-83ec56e41abe.png'
                )
              "
              alt=""
            />
          </span>
        </span>
      </template>

      <img
        class="mark-img"
        :src="
          $setPicSize(
            'https://pic2.zhuanstatic.com/zhuanzh/af5a2e81-5a2a-41f5-b395-4bc60a7f3569.png',
            150,
            150
          )
        "
        alt=""
      />
    </div>
    <VerifyMachineDialogVue :show.sync="showNotes" :info="info" />
  </div>
</template>

<script>
  import { setPicSize } from '@zz-common/zz-utils'
  import VerifyMachineDialogVue from './VerifyMachineDialog'
  import { warehousing } from '../config'
  export default {
    props: {
      qualityTeacherMsg: {
        type: Object,
        default: () => {},
      },
      info: {
        type: Object,
        default: () => {},
      },
      omsType: {
        type: Number,
        default: undefined,
      },
    },
    components: { VerifyMachineDialogVue },
    data() {
      return {
        showNotes: false,
        warehousing,
      }
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
    },
  }
</script>

<style lang="scss">
  .b2c-teacher-wrapper {
    height: 108px;
    padding: 0 32px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .teacher-company {
      display: flex;
      flex-direction: column;
      // align-items: center;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #999999;
      line-height: 20px;
      //  position: relative;
      .intro {
        font-size: 22px;
        color: #111;
        line-height: 22px;
      }
      .time {
        margin-top: 14px;
        font-size: 20px;
        color: #999;
        line-height: 20px;
        .notes {
          margin-left: 16px;
          .notes-img {
            width: 16px !important;
            height: 18px !important;
            position: relative;
            top: 1px !important;
            left: 0;
          }
        }
      }
      .mark-img {
        position: absolute;
        height: 104px;
        width: 104px;
        top: 8px;
        right: 0;
        margin-right: 44px;
        opacity: 0.8;
      }
    }
  }
</style>
